module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-stylet-logo@3x.18796956.jpg";